export default __webpack_public_path__ + "static/media/regulatory--no-heavy-goods-vehicles--g1.8a560f33.png";